module.exports = __webpack_public_path__ + "Administer_Example-273da15c46f794843ba015325650af32.png";